import request from './base'
export const otaInfo = (params) => {
    return request.post("/admin/v1/ota/info", params)
}
export const otaList = (params) => {
    return request.post("/admin/v1/ota/list", params)
}

export const otaCreate = (params) => {
    return request.post("/admin/v1/ota/create", params)
}
export const uploadFile = (params, callBack) => {
    return request.uploadFile("/admin/v1/ota/upload", params, callBack)
}
export const uploadPutFileSign = (params) => {
    return request.post("/admin/v1/ota/uploadSign", params)
}
export const uploadPutFile = (url,params, callBack,content_type) => {
    return request.uploadPutFile(url, params, callBack,content_type)
}
export const otaCarList = (params) => {
    return request.post("/admin/v1/ota/car/list", params)
}
export const otaPush = (params) => {
    return request.post("/admin/v1/ota/push", params)
}

export const otaPushLogs = (params) => {
    return request.post("/admin/v1/ota/pushLogs", params)
}


// WEBPACK FOOTER //
// ./src/api/ota.js